"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSVG = exports.PNGCollectionEncoder = void 0;
var png_collection_encoder_1 = require("./png-collection-encoder");
Object.defineProperty(exports, "PNGCollectionEncoder", { enumerable: true, get: function () { return png_collection_encoder_1.PNGCollectionEncoder; } });
var svg_builder_1 = require("./svg-builder");
Object.defineProperty(exports, "buildSVG", { enumerable: true, get: function () { return svg_builder_1.buildSVG; } });
